import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListConfig from "../Components/Configurations/listConfigs";
import AddCountryConfig from "../Components/Configurations/addCountryConfig"
import AddCitiesConfig from "../Components/Configurations/addCitiesConfig"

const ConfigRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route path="/config" element={<ListConfig></ListConfig>}></Route>
      <Route
        path="/config/add"
        element={canAdd ? <AddCountryConfig></AddCountryConfig> : <Navigate to="/config" replace />}
      ></Route>
      <Route
        path="/config/add-city"
        element={canAdd ? <AddCitiesConfig></AddCitiesConfig> : <Navigate to="/config" replace />}
      ></Route>
    </Routes>
  );
};

export default ConfigRoutes;
